import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Footer from "../Footer";
import { toast } from "react-toastify";

import axios from "axios";
import config from "../../function/config";
import Usernav from "../UserHome/Usernav";
import AdminNav from "../Admin/AdminHome/AdminNav";
import HomeNav from "../Navbars/HomeNav";
import NewAdminNav from "../Admin/AdminHome/NewAdminNav";
import NewHomeNav from "../Navbars/NewHomeNav";
import NewFooter from "../NewFooter";

export default function RegisterShipForSale() {
  const [user, setUser] = useState(null);
  const token = localStorage.getItem("token");

    const navigate = useNavigate();
    
    useEffect(() => {
        if (!token) {
          navigate('/login'); // login page
        }
      }, [token, navigate]);
      

  const [showPaymentPopup, setShowPaymentPopup] = useState(false);
  const [userShipsCount, setUserShipsCount] = useState(0);
const [maxLimit, setMaxLimit] = useState(1);
const [userPlan, setUserPlan] = useState("free");

const [isAdmin, setIsAdmin] = useState(false);

useEffect(() => {
  async function fetchUserShips() {
    try {
      const response = await axios.get(
        `${config.base_url}/api/HappyMarineShipping/userShipsCount`,
        { headers: { Authorization: `Token ${token}` } }
      );

      if (response.data.status === 200) {
        console.log('UserCount:',response)
        setUserShipsCount(response.data.current_count);
        setIsAdmin(response.data.is_admin);
        setUserPlan(response.data.plan);      // ✅ update plan
        setMaxLimit(response.data.max_limit); // ✅ update max limit
      }
    } catch (error) {
      console.log("Error fetching user ships count:", error);
    }
  }
  if (token) fetchUserShips();
}, [token]);



  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50); // Adjust the value to when you want the effect
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // Scroll to the top
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };



  useEffect(() => {
  async function fetchdata() {
    try {
      const res2 = await axios.get(
        `${config.base_url}/api/HappyMarineShipping/viewusers`,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Token ${token}`,
          },
        }
      );

      console.log("API response:", res2.data);

      if (res2.data.status === 200) {
        const userData = res2.data.data;  // ✅ Extract user object
        setUser(userData);

      } else {
        console.log(res2);
      }
    } catch (error) {
      console.log(error);
    }
  }
  fetchdata();
}, [token]);

const refreshUserPlan = async () => {
  try {
    const response = await axios.get(
      `${config.base_url}/api/HappyMarineShipping/userShipsCount`,
      { headers: { Authorization: `Token ${token}` } }
    );

    if (response.data.status === 200) {
      setUserShipsCount(response.data.current_count);
      setIsAdmin(response.data.is_admin);
      setUserPlan(response.data.plan);
      setMaxLimit(response.data.max_limit);
    }
  } catch (error) {
    console.log("Error refreshing user plan:", error);
  }
};



  const [formType, setFormType] = useState("sale"); // Default to "sale"
  const [loading, setLoading] = useState(false);
  const [Title, setTitle] = useState("");
  const [vesselType, setvesselType] = useState("");
  const [ShortDescription, setShortDescription] = useState("");
  const [Flag, setFlag] = useState("");
  const [YearBuilt, setYearBuilt] = useState("");
  const [Capacity, setCapacity] = useState("");
  const [LOA, setLOA] = useState("");
  const [Class, setClass] = useState("");
  const [GRTNRT, setGRTNRT] = useState("");
  const [Teu, setTeu] = useState("");
  const [Price, setPrice] = useState("");
  const [MainEngine, setMainEngine] = useState("");
  const [DWT, setDWT] = useState("");
  const [SubType, setSubType] = useState("");
  const userId = localStorage.getItem("user_id");

  const [Email, setEmail] = useState("");
  const [MobileNO, setMobileNO] = useState("");
  const [BriefDescription, setBriefDescription] = useState("");
  const [images, setImages] = useState([]);
  const [ThumbnailImage, setThumbnailImage] = useState("");
  const [Image, setImage] = useState("");
  const [Nationality, setNationality] = useState("");
  const [BuyAsScrap, setBuyAsScrap] = useState("");
  const [From, setFrom] = useState("");
  const [To, setTo] = useState("");
  const [InspectionCountry, setInspectionCountry] = useState("");

  const [Category, setCategory] = useState("");
  const [Subject, setSubject] = useState("");
  const vesselSubTypes = {
    Barge: [
      " Cargo Barge",
      "Tanker Barge",
      "Accommodation Barge",
      "Self-Propelled Barge",
    ],
    Bulk: [
      "Handymax Bulk Carrier",
      "Supramax Bulk Carrier",
      "Ultramax Bulk Carrier",
      "Panamax Bulk Carrier",
      "Kamsarmax Bulk Carrier",
      "Mini Bulk Carrier",
      "Post-Panamax Bulk Carrier",
      "Log Carrier",
      "Cement Carrier",
    ],
    Cargo: ["General Cargo"],
    Container: [
      "Feeder Container Ship",
      "Panamax Container Ship",
      "Post-Panamax Container Ship",
      "New Panamax (Neo-Panamax)",
      "Mega Container carrier",
      "Fully Cellular Container Ship",
      "Container Barge",
    ],
    Fishing: ["Longliner", "Purse Seiner", "Shrimp Trawler", "Stern Trawler"],
    Multipurpose: [
      "General Cargo + Container Ship",
      "General Cargo + Bulk Carrier",
      "Container + Ro-Ro Ship (ConRo)",
      "Heavy Lift Multipurpose Vessel",
      "Tweendecker (with multiple cargo decks)",
      "Livestock",
    ],
    "Passenger/Ferry": [
      "Cruise Ship",
      "High-Speed Craft",
      "Catamaran Ferry",
      "Hydrofoil",
      "Hovercraft",
      "Day Passenger Vessel",
      "Water Taxi",
    ],
    Reefer: [
      "Conventional Reefer Ship",
      "Reefer Container Ship",
      "Side Door Reefer Ship",
      "Palletized Reefer Ship",
      "Fish Reefer Vessel",
    ],
    RoRo: [
      "Pure Car Carrier (PCC)",
      "Ro-Ro Cargo Ship",
      "Ro-Pax Ship (Ro-Ro + Passenger)",
      "LOLO Cargo Ship",
      "Double-Ended Ro-Ro",
    ],
    Tanker: [
      "Crude Oil Tanker",
      "Product Tanker",
      "Chemical Tanker",
      "LNG Carrier (Liquefied Natural Gas)",
      "LPG Carrier (Liquefied Petroleum Gas)",
      "Bitumen Tanker",
      "Oil Recovery Vessel",
      "Bunker vessel ",
      "Slop Barge Tanker",
      "Water Tanker",
      "Edible Oil Tanker",
    ],
    Dredger: [
      "Cutter Suction Dredger",
      "Hopper Dredger",
      "Bucket Dredger",
      "Backhoe Dredger",
      "Grab Dredger",
    ],
    "Floating Crane": [
      "Sheerleg Crane Vessel",
      "Crane Barge",
      "Jack-Up Crane Vessel",
      "Derrick Barge",
      "Floating Gantry Crane",
    ],
    "Floating Dock": [
      "Pontoon-Type Floating Dock",
      "Submersible Floating Dock",
      "Ship-Lift Floating Dock",
      "Floating Dry Dock",
    ],
    "Landing Craft": ["Landing Craft Utility (LCU)", "Landing Craft tanker"],
    Yacht: [
      "Sailing Yacht",
      "Motor Yacht",
      "Catamaran Yacht",
      "Trimaran Yacht",
      "Superyacht",
      "Megayacht",
      "Flybridge Yacht",
    ],
    "Tug Boat": [
      "Harbor Tug",
      "Ocean Tug",
      "Escort Tug",
      "Azimuth Stern Drive (ASD) Tug",
      "Pusher Tug",
      "Anchor Handling Tug (AHT)",
    ],
    "Supply Boat": [
      "Platform Supply Vessel (PSV)",
      "Anchor Handling Tug Supply (AHTS)",
      "Utility Vessel",
      "Multi-Purpose Support Vessel (MPSV)",
      "Diving Support Vessel (DSV)",
      "Cable Laying Vessel",
      "Accommodation Supply Vessel",
      "DP Supply Boat (Dynamic Positioning)",
    ],
    "Crew Boat": [" Fast Crew Boat", "Fast Supply Intervention Vessel (FSIV)"],
    Other: [""],
  };


  const [count, setCount] = useState(0);

  const [selectedImages, setSelectedImages] = useState([]); // Array of { file, preview }

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    const newImages = files.slice(0, 3 - images.length).map((file) => ({
      file,
      preview: URL.createObjectURL(file),
    }));

    setImages((prevImages) => [...prevImages, ...newImages]);
  };

  const removeImage = (index) => {
    const updated = [...images];
    updated.splice(index, 1);
    setImages(updated);
  };

  const [generatedCode, setGeneratedCode] = useState("");

  const normalize = (str) => str.toLowerCase().replace(/[^a-z]/g, "");

  const subCategoryPrefixes = {
    barge: "BRG",
    bulk: "BLK",
    cargo: "CRG",
    container: "CNT",
    fishing: "FIS",
    multipurpose: "MPP",
    passengerferry: "PAX",
    reefer: "REF",
    roro: "ROR",
    tanker: "TNK",
    tugboat: "TUG",
    dredger: "DRG",
    floatingcrane: "FLC",
    landingcraft: "LCT",
    yacht: "YCT",
    supplyboat: "SUB",
    crewboat: "CRB",
    floatingdock: "FLD",
    other: "OTR",
  };

  useEffect(() => {
    if (vesselType) {
      const normalized = normalize(vesselType);
      const prefix = subCategoryPrefixes[normalized];
      if (prefix) {
        setGeneratedCode(prefix); // ✅ Only set the prefix
      } else {
        setGeneratedCode("");
      }
    }
  }, [vesselType]);

  const ID = localStorage.getItem("user_id");
  const [selectedPlan, setSelectedPlan] = useState(""); // "basic", "premium", "platinum"

const planDetails = {
  basic: { amount: 10, max_limit: 3 },
  premium: { amount: 100, max_limit: 15 },
  platinum: { amount: 300, max_limit: 50 },
};

const proceedToPayment = async () => {
  if (!selectedPlan) {
    toast.error("Please select a plan");
    return;
  }

  try {
    const response = await axios.post(
      `${config.base_url}/api/HappyMarineShipping/create-checkout-session/`,
      {
        plan: selectedPlan.toLowerCase(),
        success_url: window.location.href,
        cancel_url: window.location.href,
      },
      { headers: { Authorization: `Token ${token}` } }
    );

    if (response.status === 200 && response.data.url) {
      window.location.href = response.data.url;
    } else {
      toast.error("Error initiating payment");
    }
  } catch (err) {
    console.log("Checkout error:", err);
    toast.error("Payment failed");
  }
};

 useEffect(() => {
  const params = new URLSearchParams(window.location.search);
  const payment = params.get("payment");
  const sessionId = params.get("session_id");

  if (payment === "success" && sessionId) {
    axios.post(
  `${config.base_url}/api/HappyMarineShipping/verify-payment/`,
  { session_id: sessionId },
  { headers: { Authorization: `Token ${token}` } }
)
.then(res => {
  if (res.status === 200 && res.data.message === "Payment verified") {
    // Refresh plan after Stripe verification
    axios.get(`${config.base_url}/api/HappyMarineShipping/getUserPlan/`, {
      headers: { Authorization: `Token ${token}` }
    }).then(res2 => {
      if (res2.data.status === 200) {
        setUserPlan(res2.data.plan);
        setShowPaymentPopup(false);
        toast.success("Plan upgraded successfully!");
        // Clean URL
        window.history.replaceState({}, document.title, window.location.pathname);
      }
    });
  } else {
    toast.error("Payment verification failed!");
  }
})
.catch(() => toast.error("Could not verify payment."));
  }
}, [token]);

const [Url, setUrl] = useState("");


  // register ship
  // register ship
const handleSubmitSale = async (e, id) => {
  e.preventDefault();

  // ✅ Always check using values from /UserShipsCount
  console.log("DEBUG SUBMIT:", { 
    isAdmin, 
    userShipsCount, 
    userPlan, 
    maxLimit 
  });

  // if (!isAdmin && userShipsCount >= maxLimit) {
  //   toast.error(
  //     `Your ${userPlan} plan allows only ${maxLimit} ships. Please upgrade your plan to add more.`
  //   );
  //   setShowPaymentPopup(true);
  //   return;
  // }

  setLoading(true);
  const formData = new FormData();

  // Append text fields
  formData.append("title", Title);
  formData.append("vessel_type", vesselType);
  if(Url==="null" || Url ===null){
    formData.append("url_new", "")
  }else{
    formData.append("url_new", Url);
  }
  
  formData.append("sub_type", SubType);
  formData.append("short_description", ShortDescription);
  formData.append("flag", Flag);
  formData.append("year_built", YearBuilt);
  formData.append("capacity", Capacity);
  formData.append("LOA", LOA);
  formData.append("Class", Class);
  formData.append("GRT_NRT", GRTNRT);
  formData.append("Teu", Teu);
  formData.append("main_engine", MainEngine);
  formData.append("DWT", DWT);
  formData.append("Price", Price);
  formData.append("email", Email);
  formData.append("phone", MobileNO);
  formData.append("brief_description", BriefDescription);
  formData.append("ship_code", generatedCode);

  // Append multiple images
  if (images.length > 0) {
    images.forEach((imgObj) => {
      formData.append("image", imgObj.file); // ✅ file is the File object
    });
  }

  try {
    console.log("Generated Ship Code:", generatedCode);

    const response = await axios.post(
      `${config.base_url}/api/HappyMarineShipping/AddShipForSale`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Token ${token}`,
        },
      }
    );

    if (response.data.status === 200) {
      navigate("/regShip");
      console.log(response);
      setLoading(false);
      toast.success("Ship Registered Successfully!", {
        autoClose: 1500,
        position: "top-right",
      });
      setCount(id);

      // Reset form fields
      setvesselType("");
      setShortDescription("");
      setFlag("");
      setCapacity("");
      setClass("");
      setDWT("");
      setEmail("");
      setImage("");
      setMobileNO("");
      setMainEngine("");
      setGRTNRT("");
      setLOA("");
      setPrice("");
      setYearBuilt("");
      setTeu("");
      setBriefDescription("");
    } else {
      setLoading(false);
      console.log("error1");
      toast.error("Fill the required Fields", {
        autoClose: 1500,
        position: "top-right",
      });
    }
  } catch (err) {
    setLoading(false);
    console.log("error2", err);
    toast.error("Error", {
      autoClose: 2000,
      position: "top-right",
    });
  }
};


  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [pathname]);

  const [listening, setListening] = useState(false);
  const SpeechRecognition =
    window.SpeechRecognition || window.webkitSpeechRecognition;
  const recognition = SpeechRecognition ? new SpeechRecognition() : null;
  if (recognition) {
    recognition.continuous = true; // Allow continuous listening
    recognition.interimResults = false; // Only get final results
  }

  const handleTranscript = (lower) => {
    // Vessel Type
    const vesselTypes = [
      "barge",
      "bulk",
      "cargo",
      "container",
      "fishing",
      "multipurpose",
      "passenger",
      "reefer",
      "roro",
      "tanker",
      "dredger",
      "floating crane",
      "landing craft",
      "Yacht",
      "tug boat",
      "supply boat",
      "crew boat",
      "other",
    ];
    vesselTypes.forEach((type) => {
      if (lower.includes(type)) setvesselType(capitalizeWords(type));
    });

    const flagMatch = lower.match(/flag (is )?([a-z\s]+)/);
    if (flagMatch) setFlag(capitalizeWords(flagMatch[2].trim()));

    const yearMatch = lower.match(/\b(19|20)\d{2}\b/);
    if (yearMatch) setYearBuilt(yearMatch[0]);

    const capMatch = lower.match(/capacity (is )?([\d,\.]+\s*\w*)/);
    if (capMatch) setCapacity(capMatch[2].trim());

    const loaMatch = lower.match(/l o a (is )?([\d,\.]+\s*\w*)/);
    if (loaMatch) setLOA(loaMatch[2].trim());

    const grtMatch = lower.match(
      /grt(?:\/nrt)?(?: is)?(?: of)? ([\d,\.]+\s*\w*)/
    );
    if (grtMatch) setGRTNRT(grtMatch[1].trim());

    const teuMatch =
      lower.match(/(?:t e u|hp).{0,10}?(\d+(\.\d+)?)/i) ||
      lower.match(/(\d+(\.\d+)?).{0,5}?(teu|hp)/i);
    if (teuMatch) setTeu(teuMatch[1]);

    let emailText = lower.replace(/ at /g, "@").replace(/ dot /g, ".");
    const emailMatch = emailText.match(
      /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-z]{2,}/
    );
    if (emailMatch) setEmail(emailMatch[0]);

    // Replace spoken words like "plus" and "zero"
    let cleaned = lower
      .toLowerCase()
      .replace(/plus/g, "+")
      .replace(/zero/g, "0")
      .replace(/ at /g, "@")
      .replace(/ dot /g, ".")
      .replace(/[\s\-]/g, ""); // remove spaces and dashes

    const mobileMatch = cleaned.match(/(\+?\d{10,15})/);
    if (mobileMatch) {
      setMobileNO(mobileMatch[1]);
    }

    const classMatch = lower.match(/class (is )?([a-zA-Z0-9]+)/);
    if (classMatch) setClass(classMatch[2].toUpperCase());

    const engineMatch = lower.match(/main engine (is )?([a-zA-Z0-9\s\-]+)/);
    if (engineMatch) setMainEngine(capitalizeWords(engineMatch[2].trim()));

    const dwtMatch = lower.match(/dwt (is )?([\d,\.]+\s*\w*)/);
    if (dwtMatch) setDWT(dwtMatch[2].trim());

    const priceMatch = lower.match(/price (is )?([\d,\.]+\s*\w*)/);
    if (priceMatch) setPrice(priceMatch[2].trim());

    if (lower.includes("short description")) {
      const shortDesc = lower.split("short description")[1]?.trim();
      if (shortDesc) setShortDescription(capitalizeWords(shortDesc));
    }

    if (lower.includes("particular") || lower.includes("brief description")) {
      const brief =
        lower.split("particular").pop()?.trim() ||
        lower.split("brief description").pop()?.trim();
      if (brief) setBriefDescription(capitalizeWords(brief));
    }
  };

  const startListening = () => {
    if (!recognition) {
      alert("Speech Recognition is not supported in this browser");
      return;
    }

    setListening(true);
    recognition.start();

    recognition.onresult = (event) => {
      for (let i = event.resultIndex; i < event.results.length; ++i) {
        if (event.results[i].isFinal) {
          const transcript = event.results[i][0].transcript;
          console.log("Voice Input:", transcript);
          handleTranscript(transcript.toLowerCase());
        }
      }
    };
  };

  // Utility function to capitalize words
  const capitalizeWords = (text) =>
    text.replace(/\b\w/g, (char) => char.toUpperCase());

  return (
    <div className="bg-[#9ccee2]">
      {user ? user.is_superuser ? <NewAdminNav /> : <Usernav /> : <NewHomeNav />}

      <section className="mt-14 mb-10">
        <div className=" px-[30px] xm:px-[10px] w-[100%] lg:w-[90%] m-auto ">
          {/* Links for selecting form type */}
          <div className="flex justify-center gap-8 lg:flex-wrap lg:gap-5 items-center">
            <button
              onClick={() => setFormType("sale")}
              className="text-[#2e5775] text-2xl mb-3 font-bold"
            >
              Register Ship For Sale
            </button>
            
          </div>

          {/* Conditional Form Rendering */}
          <Link to={"/regShip"} className="px-3  text-[#2e5775]">
            <i className="fa-solid fa-beat fa-arrow-left "></i> Back
          </Link>
          {formType === "sale" && (
            <form className="bg-white mt-2 rounded w-full  mx-auto">
  <div className="p-5 flex justify-between items-center">
    <h1 className="text-black font-bold text-xl">Register Ship For Sale</h1>
    <div className="  z-10">
                <button
                  type="button"
                  onClick={() => {
                    if (listening) {
                      recognition.stop(); // Stop if currently listening
                      setListening(false);
                    } else {
                      startListening(); // Start if not listening
                    }
                  }}
                  className={`px-4 py-2 rounded-full shadow-lg transition-all ${
                    listening ? "bg-red-100 animate-pulse" : "bg-gray-100"
                  }`}
                >
                  {listening ? (
                    <i className="fa-solid fa-stop text-red-600 text-xl"></i> // Stop icon
                  ) : (
                    <i className="fa-solid fa-microphone text-xl"></i> // Mic icon
                  )}
                </button>
              </div>
  </div>
  <hr className="text-gray-200 w-full" />

  {/* Mic Button */}
 

  <div className="p-5 mt-5 space-y-6">
    {/* Vessel Type */}
    <div className="flex items-center gap-3">
      <label htmlFor="VesselType" className="font-semibold w-40">
        Vessel Type
      </label>
      <select
        value={vesselType}
        onChange={(e) => setvesselType(e.target.value)}
        className="flex-1 rounded border border-gray-400 p-2 text-[#d1a460]"
        id="VesselType"
      >
        <option hidden value="">
          - Select -
        </option>
        <option disabled value="">
          Categories
        </option>
        <option value="Barge">Barge</option>
        <option value="Bulk">Bulk</option>
        <option value="Cargo">Cargo</option>
        <option value="Container">Container</option>
        <option value="Fishing">Fishing</option>
        <option value="Multipurpose">Multipurpose</option>
        <option value="Passenger/Ferry">Passenger/Ferry</option>
        <option value="Reefer">Reefer</option>
        <option value="RoRo">RoRo</option>
        <option value="Tanker">Tanker</option>
        <option value="Dredger">Dredger</option>
        <option value="Floating Crane">Floating Crane</option>
        <option value="Floating Dock">Floating Dock</option>
        <option value="Landing Craft">Landing Craft</option>
        <option value="Yacht">Yacht</option>
        <option value="Tug Boat">Tug Boat</option>
        <option value="Supply Boat">Supply Boat</option>
        <option value="Crew Boat">Crew Boat</option>
        <option value="Other">Other</option>
      </select>
    </div>

    {vesselType && vesselSubTypes[vesselType] && (
      <div className="flex items-center gap-3">
        <label htmlFor="SubType" className="font-semibold w-40">
          Vessel Sub-Type
        </label>
        <select
          value={SubType}
          onChange={(e) => setSubType(e.target.value)}
          className="flex-1 rounded border border-gray-400 p-2 text-[#d1a460]"
          id="SubType"
        >
          <option hidden value="">
            - Select Sub-Type -
          </option>
          {vesselSubTypes[vesselType].map((sub, idx) => (
            <option key={idx} value={sub.trim()}>
              {sub.trim()}
            </option>
          ))}
        </select>
      </div>
    )}

    {generatedCode && (
      <div className="flex items-center gap-3">
        <label htmlFor="GeneratedCode" className="font-semibold w-40">
          Reference Id
        </label>
        <input
          value={generatedCode}
          onChange={(e) => setGeneratedCode(e.target.value)}
          className="flex-1 rounded border border-gray-400 p-2 text-gray-500"
          id="GeneratedCode"
          disabled
        />
      </div>
    )}

    {/* Short Description */}
    <div className="flex items-start gap-3">
      <label htmlFor="shortDescription" className="font-semibold w-40 mt-2">
        Short Description
      </label>
      <textarea
        placeholder="Enter Ship Name/Type/Yr Built/Country/DWT"
        value={ShortDescription}
        onChange={(e) => setShortDescription(e.target.value)}
        className="flex-1 rounded border border-gray-400 text-gray-500 p-2"
        id="shortDescription"
      ></textarea>
    </div>

    {/* Flag */}
    <div className="flex items-center gap-3">
      <label htmlFor="Flag" className="font-semibold w-40">
        Flag
      </label>
      <input
        placeholder="Enter the Country Name"
        value={Flag}
        onChange={(e) => setFlag(e.target.value)}
        className="flex-1 rounded border border-gray-400 text-gray-500 p-2"
        id="Flag"
      />
    </div>

    {/* Year Built */}
    <div className="flex items-center gap-3">
      <label htmlFor="YearBuilt" className="font-semibold w-40">
        Year Built
      </label>
      <input
        placeholder="Enter the Year"
        value={YearBuilt}
        onChange={(e) => setYearBuilt(e.target.value)}
        className="flex-1 rounded border border-gray-400 text-gray-500 p-2"
        id="YearBuilt"
      />
    </div>

    {/* LOA */}
    <div className="flex items-center gap-3">
      <label htmlFor="LOA" className="font-semibold w-40">
        Length of all: LOA(m)
      </label>
      <input
        value={LOA}
        onChange={(e) => setLOA(e.target.value)}
        className="flex-1 rounded border border-gray-400 text-gray-500 p-2"
        id="LOA"
        placeholder="Enter LOA"
      />
    </div>

    {/* Class */}
    <div className="flex items-center gap-3">
      <label htmlFor="Class" className="font-semibold w-40">
        Class
      </label>
      <input
        value={Class}
        onChange={(e) => setClass(e.target.value)}
        className="flex-1 rounded border border-gray-400 text-gray-500 p-2"
        id="Class"
        placeholder="Enter the Class"
      />
    </div>

    {/* GRT/NRT */}
    <div className="flex items-center gap-3">
      <label htmlFor="GRTNRT" className="font-semibold w-40">
        GRT/NRT
      </label>
      <input
        value={GRTNRT}
        onChange={(e) => setGRTNRT(e.target.value)}
        className="flex-1 rounded border border-gray-400 text-gray-500 p-2"
        id="GRTNRT"
        placeholder="Enter GRT/NRT"
      />
    </div>

    {/* TEU/HP */}
    <div className="flex items-center gap-3">
      <label htmlFor="Teu" className="font-semibold w-40">
        TEU/HP
      </label>
      <input
        value={Teu}
        onChange={(e) => setTeu(e.target.value)}
        className="flex-1 rounded border border-gray-400 text-gray-500 p-2"
        id="Teu"
        placeholder="Enter TEU/HP"
      />
    </div>

    {/* Main Engine */}
    <div className="flex items-center gap-3">
      <label htmlFor="MainEngine" className="font-semibold w-40">
        Main Engine
      </label>
      <input
        value={MainEngine}
        onChange={(e) => setMainEngine(e.target.value)}
        className="flex-1 rounded border border-gray-400 text-gray-500 p-2"
        id="MainEngine"
        placeholder="Enter Main Engine"
      />
    </div>

    {/* DWT */}
    <div className="flex items-center gap-3">
      <label htmlFor="DWT" className="font-semibold w-40">
        DWT
      </label>
      <input
        value={DWT}
        onChange={(e) => setDWT(e.target.value)}
        className="flex-1 rounded border border-gray-400 text-gray-500 p-2"
        id="DWT"
        placeholder="Enter DWT"
      />
    </div>

    {/* Price */}
    <div className="flex items-center gap-3">
      <label htmlFor="Price" className="font-semibold w-40">
        Price (USD)
      </label>
      <input
        value={Price}
        onChange={(e) => setPrice(e.target.value)}
        className="flex-1 rounded border border-gray-400 text-gray-500 p-2"
        id="Price"
        placeholder="Enter the Price"
      />
    </div>

    {/* Email */}
    <div className="flex items-center gap-3">
      <label htmlFor="Email" className="font-semibold w-40">
        Email
      </label>
      <input
        value={Email}
        onChange={(e) => setEmail(e.target.value)}
        className="flex-1 rounded border border-gray-400 text-gray-500 p-2"
        id="Email"
        placeholder="Enter your Email"
      />
    </div>

    {/* Mobile No */}
    <div className="flex items-center gap-3">
      <label htmlFor="MobileNO" className="font-semibold w-40">
        Mobile No
      </label>
      <input
        value={MobileNO}
        onChange={(e) => setMobileNO(e.target.value)}
        className="flex-1 rounded border border-gray-400 text-gray-500 p-2"
        id="MobileNO"
        placeholder="Enter Your Mobile No"
      />
    </div>

    {user?.is_superuser && (
      <div className="flex items-center gap-3">
      <label htmlFor="URL" className="font-semibold w-40">
       URL
      </label>
      <input
        value={Url}
        onChange={(e) => setUrl(e.target.value)}
        className="flex-1 rounded border border-gray-400 text-gray-500 p-2"
        id="Url"
        placeholder="Enter Your Url"
      />
    </div>
    )}

    {/* Brief Description */}
    <div className="flex items-start gap-3">
      <label htmlFor="BriefDescription" className="font-semibold w-40 mt-2">
        Ship Particular
      </label>
      <textarea
        value={BriefDescription}
        onChange={(e) => setBriefDescription(e.target.value)}
        rows={5}
        className="flex-1 rounded border border-gray-400 text-gray-500 p-2"
        id="BriefDescription"
        placeholder="Write about your ship in brief..."
      ></textarea>
    </div>

    

    {/* Upload Images */}
    <div>
      {images.length > 0 && (
        <div className="flex gap-4 mb-4 flex-wrap">
          {images.map((img, index) => (
            <div key={index} className="relative w-28 h-28">
              <img
                src={img.preview}
                alt={`preview ${index}`}
                className="w-full h-full rounded border border-gray-300"
              />
              <button
                onClick={() => removeImage(index)}
                className="absolute top-0 right-0 bg-red-500 text-white text-xs px-1 rounded-bl"
              >
                ✕
              </button>
            </div>
          ))}
        </div>
      )}

      <label htmlFor="image">Upload Images (Max 3 Images)</label>
      <input
        type="file"
        onChange={handleImageChange}
        multiple
        accept="image/*"
        className="w-full mt-2 rounded border border-gray-400 text-gray-500 p-2"
        id="image"
        disabled={selectedImages.length >= 3}
      />
    </div>
  </div>

  {/* Submit */}
  <hr className="text-gray-300 w-full" />
  <div className="p-4">
    <button
      onClick={(e) => handleSubmitSale(e)}
      type="submit"
      className="bg-green-600 hover:bg-green-500 text-white px-5 py-2 rounded w-full"
    >
      {loading ? (
        <span className="block w-[16px] h-[16px] border-2 border-b-0 border-white rounded-full m-auto animate-spin"></span>
      ) : (
        "Submit"
      )}
    </button>
  </div>
</form>
          )}
        </div>
      </section>

      {/* Go to Top Button */}
      {isScrolled && (
        <div
          className="fixed bottom-16 right-8 z-50 " // Ensure it's in the right position with high z-index
        >
          <div
            className="back-to-top px-4 hover:bg-[#615d91]"
            onClick={scrollToTop}
          >
            <i className="fa-solid fa-arrow-up text-2xl"></i>
          </div>
        </div>
      )}
      {showPaymentPopup && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white rounded-2xl shadow-lg p-6 w-[400px]">
            <h2 className="text-xl font-bold mb-4">
              Choose a Plan to Register More Ships
            </h2>
            <div className="space-y-3">
  <div
    className={`border p-3 rounded cursor-pointer ${
      selectedPlan === "basic" ? "border-blue-500 bg-blue-100" : "border-gray-300"
    }`}
    onClick={() => setSelectedPlan("basic")}
  >
    <h3 className="font-bold">Basic Plan</h3>
    <p>$10 — Register up to 3 ships</p>
  </div>

  <div
    className={`border p-3 rounded cursor-pointer ${
      selectedPlan === "premium" ? "border-blue-500 bg-blue-100" : "border-gray-300"
    }`}
    onClick={() => setSelectedPlan("premium")}
  >
    <h3 className="font-bold">Premium Plan</h3>
    <p>$100 — Register up to 15 ships</p>
  </div>

  <div
    className={`border p-3 rounded cursor-pointer ${
      selectedPlan === "platinum" ? "border-blue-500 bg-blue-100" : "border-gray-300"
    }`}
    onClick={() => setSelectedPlan("platinum")}
  >
    <h3 className="font-bold">Platinum Plan</h3>
    <p>$300 — Register up to 50 ships</p>
  </div>
</div>




            <div className="mt-5 flex justify-end">
              <button
                onClick={() => setShowPaymentPopup(false)}
                className="px-4 py-2 bg-gray-300 rounded mr-2"
              >
                Cancel
              </button>
              <button
  onClick={proceedToPayment}
  className=" px-4 py-2 bg-blue-600 text-white rounded"
>
  Proceed to Payment
</button>
            </div>
          </div>
        </div>
      )}

      <NewFooter />
    </div>
  );
}
